import React from 'react';
import PropTypes from 'prop-types';
import Timings from '../Timings/TimingsComponent';
import DayGrid from '../DayGrid/DayGridComponent';
import './DayScheduleComponent.scss';

class DaySchedule extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      scrollTop: 0,
    };
    this.dayCalendarRef = React.createRef();
  }

  componentWillReceiveProps(nextProps) {
    const { scrollTop } = this.state;
    if (nextProps.scrollTop !== scrollTop && this.dayCalendarRef) {
      this.dayCalendarRef.current.scrollTop = nextProps.scrollTop;
      this.setState({
        scrollTop: nextProps.scrollTop,
      });
    }
  }

  render() {
    const { date, updateEvent, externalCalendarSlots, settings, deleteEvent } = this.props;
    const events = [];
    const { eventsById, eventsByDate } = this.props;
    const eventIds = eventsByDate[date.format('DDMMYYYY')];
    if (eventIds !== undefined) {
      for (let i = 0; i < eventIds.length; i += 1) {
        events.push(eventsById[eventIds[i]]);
      }
      events.sort((a, b) => a.StartTime - b.StartTime);
    }

    return (
      <div className="day-calendar" ref={this.dayCalendarRef}>
        <Timings />
        <div className="day-parent">
          <DayGrid
            events={events}
            date={date}
            parent="in-day"
            updateEvent={updateEvent}
            busySlots={externalCalendarSlots}
            startingFreeTime={settings.StartingFreeTime}
            deleteEvent={deleteEvent}
          />
        </div>
      </div>
    );
  }
}

DaySchedule.propTypes = {
  eventsById: PropTypes.shape({}),
  eventsByDate: PropTypes.shape({}),
  settings: PropTypes.shape({
    StartingFreeTime: '',
  }),
  date: PropTypes.shape({}),
  updateEvent: PropTypes.func.isRequired,
  deleteEvent: PropTypes.func.isRequired,
  externalCalendarSlots: PropTypes.arrayOf(PropTypes.shape({})),
  scrollTop: PropTypes.number,
};

DaySchedule.defaultProps = {
  eventsById: {},
  eventsByDate: {},
  settings: {
    StartingFreeTime: '',
  },
  date: {},
  externalCalendarSlots: [],
  scrollTop: 0,
};

export default DaySchedule;
